import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-table-up",
  "use": "icon-table-up-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol viewBox=\"0 0 11 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-table-up\">\n<path d=\"M9.76172 5.99951L5.26172 1.49951L0.761719 5.99951\" stroke=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol